import { getFormatDisplayName } from '@/components/common/ProductUtilities';
import i18n from '@/assets/i18n/i18n';
import { GroupedProduct } from './useGroupedProducts';
import { getCmsProductUrl } from '@/helpers/productUrls';

export type CommonProduct = {
  id?: string | number | null;
  title?: string | null;
  version?: string | null;
  format?: string | null;
  packaging?: string | null;
  displayArtist?: string | null;
  releaseDate?: string | null;
  gtin?: string | null;
  catalogNumber?: string | null;
  state?: string | null;
  editUrl?: string | null;
  groupedProductType: 'PRS' | 'CMS';
};

export default function mapToCommonProduct(
  album: GroupedProduct
): CommonProduct {
  switch (album.groupedProductType) {
    case 'PRS':
      return {
        id: album.id,
        title: album.title,
        version: album.albumMetaData?.versions?.at(0),
        format: getFormatDisplayName(album.format),
        packaging: album.packaging?.name,
        displayArtist: album.displayArtist,
        releaseDate: album.releaseDate,
        gtin: album.gtin,
        catalogNumber: album.catalogNumber,
        state: album.albumState,
        editUrl: album.id ? `/Physical/EditProduct/Album/${album.id}` : null,
        groupedProductType: 'PRS',
      };
    case 'CMS':
      return {
        id: album.id,
        title: album.title,
        version: album.version ?? album.additionalVersions?.at(0)?.version,
        format: album.productType
          ? i18n.t(
              `common.digitalProductTypeShort.${album.productType}`,
              album.productType
            )
          : album.productType,
        displayArtist: album.primaryContributor,
        releaseDate: album.releaseDate?.substring(0, 10),
        catalogNumber: album.catalogNumber,
        state: album.submissionState,
        editUrl:
          album.id && album.productType
            ? getCmsProductUrl(album.id, album.productType)
            : null,
        gtin: album.idTypes?.stringGtin,
        groupedProductType: 'CMS',
      };
  }
}
